import { Pane, Text } from 'evergreen-ui';
import styled from 'styled-components';
import ShiftsListItem from './ShiftsListItem';

export const StyledList = styled(Pane)`
  display: flex;
  flex-direction: column;
  position: absolute;
  overflow: auto;
  max-height: calc(100% - 64px);
  width: 100%;
  margin-top: 64px;
  padding-top: 10px;
  padding-bottom: 60px;
`;

const LogsList = ({ items }) => {
  return (
    <Pane background="#1F2021" position="relative" display="flex" flex={1} height="100%" flexDirection="column">
      <Text
        color="#FFFFFF"
        background="#1F2021"
        boxShadow="0 0 14px 12px #1F2021"
        fontSize={22}
        fontWeight={900}
        padding={30}
        paddingBottom={10}
        textAlign="center"
        marginBottom={15}
        zIndex={2}
      >
        Logs
      </Text>
      {items?.length > 0 ? (
        <StyledList>
          {items.map((item, key) => (
            <ShiftsListItem item={item} key={key} />
          ))}
        </StyledList>
      ) : (
        <Pane display="flex" justifyContent="center" alignItems="center" color="#A7AAAC" height="100%">
          There are no logs yet
        </Pane>
      )}
      <Pane
        position="absolute"
        bottom={0}
        height={0}
        width="100%"
        boxShadow="0 0 14px 22px #1F2021"
        background="#1F2021"
      />
    </Pane>
  );
};

export default LogsList;
